import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchDataMain } from "../../api/api";
import { fetchDataMainSuccess, fetchDataMainRequest, createAnswerSuccess, updateAnswerSuccess, createQuestionnaireSuccess, updateQuestionnaireSuccess, fetchCommentsOnlyRequest } from "./data-main";
import { BACKEND_URL, STRAPI_TOKEN } from "../../api/config";

export function* handleFetchDataMain(action: ReturnType<typeof fetchDataMainRequest>): SagaIterator {
  const params = action.payload;
  const data = yield call(fetchDataMain, params);
  yield put(fetchDataMainSuccess({ data, params }));
  yield put(fetchCommentsOnlyRequest(action.payload));
}

export function* handleCreateAnswer(action) {
  try {
    const response = yield fetch(`${BACKEND_URL}/api/gop-answers`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: action.payload }),
      
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при создании ответа');
    }

    const created = yield response.json();

    console.log('Data', created);

    const getResponse = yield fetch(`${BACKEND_URL}/api/gop-answers?filters[id][$eq]=${created.data.id}&populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
    const fullData = yield getResponse.json();
    console.log('fullData', fullData);

    yield put(createAnswerSuccess(fullData));
  } catch (error) {

  }
}

export function* handleUpdateAnswer(action) {
  try {
    const { id, answer } = action.payload;

    const response = yield fetch(`${BACKEND_URL}/api/gop-answers/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: { answer: answer } }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при обновлении ответа');
    }

    const result = yield response.json();

    console.log('result', result)

    yield put(updateAnswerSuccess(result));
  } catch (error) {

  }
}

export function* handleUpdateQuestionnaire(action) {
  try {
    const { id, statusQuestionnaire, completionDate, nameCompleted } = action.payload;

    const response = yield fetch(`${BACKEND_URL}/api/gop-status-questionnaires/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: { statusQuestionnaire: statusQuestionnaire, completionDate, nameCompleted } }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при обновлении опросника');
    }

    const result = yield response.json();

    console.log('result', result)

    yield put(updateQuestionnaireSuccess(result));
  } catch (error) {

  }
}

export function* handleCreateQuestionnaire(action) {
  try {
    const response = yield fetch(`${BACKEND_URL}/api/gop-status-questionnaires`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STRAPI_TOKEN}`,
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ data: action.payload }),
    });

    if (!response.ok) {
      const errorData = yield response.json();
      throw new Error(errorData?.error?.message || 'Ошибка при создании опросника');
    }

    const result = yield response.json();

    yield put(createQuestionnaireSuccess(result));
  } catch (error) {
  }
}
